<script lang="ts" setup>
import MainLayout from '../components/layouts/MainLayout.vue'
import ItemList from '../components/items/ItemList.vue'
import { ref } from 'vue'

const props = defineProps<{ id: string }>()
const appendingItems = ref<boolean>(false)

// function onAppendStatus(status: boolean) {
//   appendingItems.value = status
// }
</script>

<template>
  <MainLayout>
    <ItemList v-if="!appendingItems" :id="props.id" />
    <!--    <ItemAppend :id="props.id" @append-status="onAppendStatus" />-->
  </MainLayout>
</template>
